<nz-card>
  <div class="d-flex justify-content-between">
    <span class="table-title">{{title}}</span>
  </div>
  
  <nz-divider></nz-divider>
  <nz-table #listViewTable [nzData]="list" [nzShowPagination]="false" [nzFrontPagination]="false">
    <thead>
    <tr>
      <th>Tên</th>
      <th>Ngày hiệu lực</th>
      <th>Kích hoạt</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of listViewTable.data; trackBy: trackId; index as index">
      <td>
        <a [href]="item.url" target="_blank">
          {{item.fileName}}
        </a>
      </td>
      <td>{{item.applyAt}}</td>
      <td>
        <nz-switch [(ngModel)]="item.isEnable" nzCheckedChildren="Kích hoạt" nzUnCheckedChildren="Khóa"
        (ngModelChange)="updateDocument(item)"></nz-switch>
      </td>
      <td>
        <button type="button" class="btn dropdown-toggle" (click)="confirmDelete(item)">
          <span nz-icon nzType="delete" nzTheme="outline" style="font-size: 24px;"></span>
        </button>
      </td>
    </tr>
    </tbody>
  </nz-table>
  <div class="ant-table-pagination ant-pagination">
    <nz-pagination [nzPageIndex]="queryParams.page" [nzTotal]="queryParams.totalItems" [nzPageSize]="queryParams.size"
                   [nzShowTotal]="rangeTemplate" (nzPageIndexChange)="loadPage($event)"></nz-pagination>
    <ng-template #rangeTemplate let-range="range" let-total>
      {{ range[0] }} - {{ range[1] }} of {{ queryParams.totalItems }} items
    </ng-template>
  </div>
</nz-card>

